export class DataProtectError extends Error {}
